import {useColors} from "../../providers/queryClient";
import {RadioGroup} from "@headlessui/react";
import {classNames} from "../../providers/utils";
import React from "react";
import {useTranslation} from "react-i18next";
import {Color} from "../../providers/types";

export interface ColorSelectorProps {
    selectedColor: Color | null;
    setSelectedColor: (color: Color) => void;
}

const ColorSelector = ({selectedColor, setSelectedColor}: ColorSelectorProps) => {
    const {data} = useColors();
    const {t} = useTranslation();

    React.useEffect(() => {
        if(data){
            setSelectedColor(data['pastel'][1])
        }
    }, [data]);

    if (!data) {
        return null;
    }

    return (
        <div>
            <h2 className="text-base font-medium text-gray-900">{t('CONFIG.COLOR')}</h2>

            <fieldset aria-label="Choose a color" className="mt-2">
                <RadioGroup value={selectedColor} onChange={(color) => setSelectedColor(color!)}
                            className="flex gap-4 flex-col">
                    {Object.keys(data).map((colorGroup) => {
                        return (
                            <div key={colorGroup} className="flex flex-col gap-2">
                                <h3 className="text-xs font-medium text-gray-900">{t('COLOR.' + colorGroup.toUpperCase())}</h3>
                                <div className="flex items-center space-x-3">
                                    {(data[colorGroup]).map((color) => (
                                        <RadioGroup.Option
                                            key={color._id}
                                            value={color}
                                            aria-label={color.name}
                                            style={{
                                                borderColor: color.borderColor,
                                            }}
                                            className={({checked}) =>
                                                classNames(
                                                    checked ? 'ring ring-offset-1' : '',
                                                    checked ? 'ring-2' : '',
                                                    'relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none'
                                                )
                                            }
                                        >
                        <span
                            aria-hidden="true"
                            style={{
                                backgroundColor: color.code,
                            }}
                            className={'h-8 w-8 rounded-full border border-black border-opacity-10'}
                        />
                                        </RadioGroup.Option>
                                    ))}
                                </div>
                            </div>
                        )

                    })}
                </RadioGroup>
            </fieldset>
        </div>
    )
}

export default ColorSelector;